export const sslOptions = {
  key: `-----BEGIN PRIVATE KEY-----
MIIEvQIBADANBgkqhkiG9w0BAQEFAASCBKcwggSjAgEAAoIBAQDWdQHii2chN7zF
hJeDVxMELoL4tWdG9e5hi+wUanMgS6Djsp450GxptXBMaGlHE3+ISZkH/DkYF6Wj
Kue2Epl2rbqMvw32ISObV0dkyxD8dGqAV5c3irqffAMELQyX1vhku77kXVmiFKtJ
W/a/gN2eOsPTmApwGMyz6JXqHQJmqknT6HcQd6FSU0ac+5XC3C/uavI6FkHvlIf6
8Em25iP5ZUzFC1/fLcsKO0xSIFkKWRTjcGv/VSuRB0ssJMl/5s2XBoB0AahQBSXD
aYHLutVaeEOR0zN1RlMBop6p8YPRtxtVNR7KAJmblG3tkd8qriZERxuozyGNOsEx
6Jx48lKdAgMBAAECggEAIi64RDHQGF1X+2us8sRYRZxcR+QyN/9PJcE1ufNVslob
pO99hN2Ryi+fXK5vyWJ0O3bvq3QqbYqnXiCimkTQrTf3uiNhyE9z63i36nrrlDHC
H/7WHYZBRNZxbKL5lOIw6W17ec7fUJRW0PSVmeSibmwTdpCPaVqqliqGarCBB3fm
YQsvpmHy7AhfhEv7YEu6tQAAMQ1SPA+TaX/oaAfmloUHho3PgrbqnWFpKD50pSE1
Qgz17BaRVzP6YP5dJ4vJcbqyT/4bTU7KEkazF5fIG2OKCOId/Aomt8FVmTDF0mni
n2UDVHSGL16rsThfR+bawu7NU9yUTo5JAQYL1epnyQKBgQDwG29Pdhz+HgtEEuIb
c1DVbuqLryxG1u0d/7/hcMsmgszBZVMf2003KPKXUYyItIvf5eI3+IYGsgH3Ffoz
ENYXmbRsVrHw8sAtqwisg3xqxTLn5LTpD1rRAFxCHvBYg667Tg0bQQ6bWHyA04A7
SDw3fUNRyFrTJ1H/oS4ZwlQpswKBgQDkpu/ZfDhkz1Rr5zB5LTUdBENZVQKzjREZ
3bMIKLCEPcxNVRmXGaEF4RZbRCDOI8MNNZK2kvokrkTDRoZjHlDxpsIsKdlESzrj
MGzbZtsrntZbB1lt4WIBS+v+3Uo5ZErQCuPqZ1/RXi1eRxx1wXSQL4X2nDqpY6Pa
bq/nC7/KbwKBgFIGvVcjHbJ+pxChdtcz5PiVRNFljbXBtQ3bkjy9INnOM48aQ3SN
oepnNcEWHfGR5Hsf+NFwOLFO3LcBrhEF/m3fl7CvSWjsNVUkqfjtjnKXXdW0300D
bt4ZxmrcUPWcPvRELNwTtJ7Dcv07xAH8on2+cGIfFVAvjabL9IjeR4xbAoGAcLdG
l4zf8/os4MBoKeQ6QaKfXMNGgKKy4nBi2EvOsHISa7De25jbwx0xuy37igMhHTri
pzQPMdPiu+zhRK1mM6oEIGdE3qDDV8nAb+vlcTxs6RTXZg5sFL2LiekmtOIW6zXj
IuNw3bIyZT5i7j2+q3Fx9Z8QX/5pgL1940Tsd+sCgYEAw309T0XfnlYIzyrBme6e
3kb3LQgmmdM3ssNdI9mSbKxuMwzdmvRc/4Dz1Y5spHlSU7/suxx2mu4fTI+Dc6IO
oGGKce1XWjL9yajsgGate3g0GUzIYxCEM3DUcSee7Dn5V2iRwcVlkpOQ9shyRuJf
Aw2JcAE4aID7Yb/tc4OVJsQ=
-----END PRIVATE KEY-----
`,
  cert: `-----BEGIN CERTIFICATE-----
MIID+zCCAuOgAwIBAgIUAOml4wd0Fq3O6mlGx4HSPp/FdygwDQYJKoZIhvcNAQEL
BQAwgYYxCzAJBgNVBAYTAlJVMQ4wDAYDVQQIDAVTdGF0ZTERMA8GA1UEBwwITG9j
YXRpb24xGjAYBgNVBAoMEU9yZ2FuaXphdGlvbiBOYW1lMRwwGgYDVQQLDBNPcmdh
bml6YXRpb25hbCBVbml0MRowGAYDVQQDDBF3d3cubG9jYWxob3N0LmNvbTAeFw0y
MDA1MTIxMDM1MTRaFw0yMTA1MTIxMDM1MTRaMIGGMQswCQYDVQQGEwJSVTEOMAwG
A1UECAwFU3RhdGUxETAPBgNVBAcMCExvY2F0aW9uMRowGAYDVQQKDBFPcmdhbml6
YXRpb24gTmFtZTEcMBoGA1UECwwTT3JnYW5pemF0aW9uYWwgVW5pdDEaMBgGA1UE
AwwRd3d3LmxvY2FsaG9zdC5jb20wggEiMA0GCSqGSIb3DQEBAQUAA4IBDwAwggEK
AoIBAQDWdQHii2chN7zFhJeDVxMELoL4tWdG9e5hi+wUanMgS6Djsp450GxptXBM
aGlHE3+ISZkH/DkYF6WjKue2Epl2rbqMvw32ISObV0dkyxD8dGqAV5c3irqffAME
LQyX1vhku77kXVmiFKtJW/a/gN2eOsPTmApwGMyz6JXqHQJmqknT6HcQd6FSU0ac
+5XC3C/uavI6FkHvlIf68Em25iP5ZUzFC1/fLcsKO0xSIFkKWRTjcGv/VSuRB0ss
JMl/5s2XBoB0AahQBSXDaYHLutVaeEOR0zN1RlMBop6p8YPRtxtVNR7KAJmblG3t
kd8qriZERxuozyGNOsEx6Jx48lKdAgMBAAGjXzBdMA4GA1UdDwEB/wQEAwIDiDAT
BgNVHSUEDDAKBggrBgEFBQcDATA2BgNVHREELzAtghF3d3cubG9jYWxob3N0LmNv
bYINbG9jYWxob3N0LmNvbYIJbG9jYWxob3N0MA0GCSqGSIb3DQEBCwUAA4IBAQCV
qC6pYUEQ/AWxgmN2YvDFgrkMH+kgN8ld+PJu9RWmc/TKM1hYTQu0+u1O4UhlS7h0
/F+W+CUIQ5vjsj/iHqwyJyp9LxdBEbSQvZ8Ua48S+FGIHjCTUWQGGyFX0R4b8qGg
CXZE7ztcfpubK2r2IeXId+8oRnYmsFz+UOoVQdlU/NKMuQgYwnw9/lsFEKLX/Ja+
jvyCrGIRPhIlenvFEGFb97AxXx258HC/QxavmsfJzRLQ+RRqCzJkix5o1GZwQebe
K2wUV9kHFQXJT4Ox3yGFRbn1T69ayD8INJ3TQHaq4f6ssaV46SJZS3RURHfyuVir
/g37+xZlNm8OXQsN7euo
-----END CERTIFICATE-----
`,
};
